import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Avatar, Typography } from '@mui/material';

import { getInitials } from 'helpers';
import { getAgendaColor } from 'commons/helpers/agendaTheme';
import { currentUserSelector, useAppStore } from 'stores/appStore';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content',
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  avatar: {
    width: 30,
    height: 30,
    fontSize: '14px',
    // marginRight: theme.spacing(2),
    borderWidth: '2px',
    borderStyle: 'solid',
    '@media (max-height:750px)': {
      display: 'none',
    },
  },
  name: {
    marginTop: '5px',
    // width: '180px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'center',
  },
}));

// COMPONENT
function Profile({ open, className, ...rest }) {
  const { classes, cx } = useStyles();
  const currentUser = useAppStore(currentUserSelector);

  if (currentUser == null || currentUser.principal == null) {
    return <div />;
  }

  const agendaColor = getAgendaColor(currentUser.principal.agendaColorId);

  return (
    <div {...rest} className={cx(classes.root, className)}>
      {/* <Badge
        overlap="circle"
        // color="primary"
        // badgeContent=" "
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        badgeContent={
          <FontAwesomeIcon
            icon="caret-down"
            color={theme.palette.primary.main}
            style={{ fontSize: 25 }}
            transform={{ rotate: -45 }}
          />
        }
        // variant="standard"
      >
      </Badge> */}
      {/* <Avatar
        style={{ backgroundColor: agendaColor.base }}
        className={classes.avatar}
      >
        {getInitials(currentUser.principal.name)}
      </Avatar> */}

      <Avatar
        style={{
          backgroundColor: agendaColor?.base ?? 'black',
          borderColor: agendaColor?.header ?? 'black',
          color: agendaColor.text ?? 'white',
        }}
        className={classes.avatar}
      >
        {getInitials(currentUser.principal.name)}
      </Avatar>

      {open && (
        <Typography className={classes.name} variant="h6">
          {currentUser.principal.name}
        </Typography>
      )}
    </div>
  );
}

export default Profile;
